import { getProduct } from '@/context/AppContext'
import { useAuth } from '@/context/AuthContext'
import { useApp } from '@/hooks/useApp'
import { Icon, useBreakpointValue } from '@chakra-ui/react'
import { faPlusLarge } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SplitButton } from 'BrokerTsLib/src/components'
import { InsuranceParamsType, Product } from 'BrokerTsLib/src/enums'
import { StyledMenuItem } from './Header'

export const NewInsuranceButton = ({
  allowNewExtraInsurance, enableContractReplacement, newDailyPov, step1Path, liabilityInsurance, newStockInsurance
}: {
  allowNewExtraInsurance?: boolean
  enableContractReplacement?: boolean
  newDailyPov?: boolean
  newStockInsurance?: boolean
  step1Path: string
  liabilityInsurance: boolean
}) => {
  const { user } = useAuth()
  const { lastApp, setProduct } = useApp()

  const arr = []
  if (liabilityInsurance) {
    arr.push(
      <StyledMenuItem
        key={4}
        to={`${step1Path}?new`}
        onClick={() => setProduct(Product.LiabilityInsurance)}
      >
        Pojištění odpovědnosti
      </StyledMenuItem>
    )
  }

  if (user?.enablePoleasEssox) {
    arr.push(
      <StyledMenuItem
        key={4}
        to={`${step1Path}?new&type=${InsuranceParamsType.Poleas}`}
        onClick={() => setProduct(getProduct(lastApp?.app ?? null))}
      >
        Poleasing 1
      </StyledMenuItem>
    )
    arr.push(
      <StyledMenuItem
        key={5}
        to={`${step1Path}?new&type=${InsuranceParamsType.Poleas2}`}
        onClick={() => setProduct(getProduct(lastApp?.app ?? null))}
      >
        Poleasing 2
      </StyledMenuItem>
    )
  }

  if (allowNewExtraInsurance) {
    arr.push(
      <StyledMenuItem
        key={1}
        to="/extra/steps/1?new"
        onClick={() => setProduct(getProduct(lastApp?.app ?? null))}
      >
        Pojištění doplňků
      </StyledMenuItem>
    )
  }

  if (enableContractReplacement) {
    arr.push(
      <StyledMenuItem
        key={3}
        to={`${step1Path}?new&contractReplacement`}
        onClick={() => setProduct(getProduct(lastApp?.app ?? null))}
      >
        Náhrada smlouvy
      </StyledMenuItem>
    )
  }

  if (newDailyPov) {
    arr.push(
      <StyledMenuItem
        key={2}
        to="/shortInsurance?new"
        onClick={() => setProduct(getProduct(lastApp?.app ?? null))}
      >
        Denní POV
      </StyledMenuItem>
    )
  }

  if (newStockInsurance) {
    arr.push(
      <StyledMenuItem
        key={6}
        to="/leasing/stock?new"
      >
        Skladové pojištění
      </StyledMenuItem>
    )
  }

  const newInsuranceText = useBreakpointValue(
    { base: <Icon as={FontAwesomeIcon} icon={faPlusLarge} size='lg' />, md: 'Nové pojištění' },
    { fallback: 'md' }
  )

  return (
    <SplitButton
      buttonProps={{
        as: StyledMenuItem,
        to: `${step1Path}?new`,
        children: newInsuranceText,
        onClick: () => setProduct(getProduct(lastApp?.app ?? null)),
      }}
      splitterColor="primary.600"
      menuItems={arr.length == 0 ? undefined : arr}
      popoverStyle={{}} />
  )
}
